<script setup>
import { ref, computed, defineAsyncComponent, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
/***/
import { useApplicationStore } from '@stores/application';
/***/
import { useAuthUser } from '@compositions/Auth';
import { useTaskConfiguration } from '@compositions/Task/Configuration/TaskConfiguration';

// Composants
const Loader = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/UI/Loader'));
const Layout = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Layouts/Authenticated'));
const VideoList = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Admin/Videos/List/Wrapper'));
const AddButton = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Admin/Videos/AddButton'));
const ImportButton = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Admin/Videos/Import/ImportButton'));

const router = useRouter();
const { t } = useI18n();

// Store
const applicationStore = useApplicationStore();

// Application et utilisateur connecté
const currentApplication = computed(() => applicationStore.getCurrent);
const { authUserHasPermission } = useAuthUser({});

const allowed = ref(false);

// Composition pour le chargement des configurations de tâche
const {
    loadingTaskConfigurations,
    loadingTaskConfigurationsError,
    loadTaskConfiguration
} = useTaskConfiguration({});

onMounted(() => {

    const canConsult = (authUserHasPermission('edit task configuration'));

    if(! canConsult) {
        router.push({
            name: 'error',
            params: {
                statusCode: 404
            }
        });
    } else {
        const titleKey = 'page.admin.videos.list.title';
        document.title = t(titleKey) + ' - ' + currentApplication.value.name;
        allowed.value = true;

        loadTaskConfiguration();
    }
});
</script>

<template>
    <layout v-if="allowed">

        <loader v-if="loadingTaskConfigurations"></loader>
        <p
            v-else-if="loadingTaskConfigurationsError"
            class="generic-message generic-message-error"
        >
            {{ $t('page.admin.videos.list.loadTaskConfigurations.error') }}
        </p>
        <template v-else>
            <div class="content_header">
                <div class="content-header_title">
                    <h1 class="first-title">{{ $t('page.admin.videos.list.title') }}</h1>
                    <p>{{ $t('page.admin.videos.list.description') }}</p>
                </div>
                <div class="content-header_btn">
                    <add-button></add-button>
                    <import-button></import-button>
                </div>
            </div>
            <video-list></video-list>
        </template>
    </layout>
</template>
